export default __webpack_public_path__ + "static/media/HUL.b578c0dd.png";